import Session from "services/Session";
import * as moment from "moment";

export class Formaters {

    static format(...args: any[]): string {
        var i = 0;
        var string = args[i++];
        for (; i < args.length; i++) {
            string = string.replace(/\{\d+?\}/, args[i]);
        }
        return string;
    }

    static playTime(seconds?: number): string {
        if (typeof (seconds) != "number") return "?";
        var h = Math.floor(seconds / 3600);
        var m = Math.floor((seconds - (seconds / 3600)) / 60);
        var s = Math.floor((seconds - (seconds / 3600)) % 60);
        return Formaters.format("{0}h {1}m {2}s", h, m, s);
    }

    static dateDiff(endDate: Date, startDate: Date): string {
        var diff = endDate.getTime() - startDate.getTime();
        var h = Math.round(diff / 86400000);
        var m = Math.round(((diff % 86400000) / 3600000));
        var s = Math.round(((diff % 86400000) % 3600000) / 60000);
        return h + ":" + Formaters.padZero(m, 2) + ":" + Formaters.padZero(s, 2);
    }

    static minutes(minutes: number): string {
        var h = Math.floor(minutes / 60);
        var m = Math.round(minutes % 60);
        return h + ":" + Formaters.padZero(m, 2) + "h";
    }

    static padZero(n: number, digits: number): string {
        return ("0".repeat(digits) + n).slice(-digits);
    }

    static number(n: number, decimals: number): string {
        return n.toLocaleString(Session.uiCulture, { maximumFractionDigits: decimals });
    }

    static currency(n: number): string {
        return Formaters.number(n, 2);
    }

    static ticksToDurationString(ts: number): string {
        ts = ts / 10000;

        var days = Math.floor(ts / (1000 * 60 * 60 * 24));
        ts -= days * (1000 * 60 * 60 * 24);

        var hours = Math.floor(ts / (1000 * 60 * 60));
        ts -= hours * (1000 * 60 * 60);

        var mins = Math.floor(ts / (1000 * 60));
        ts -= mins * (1000 * 60);

        var seconds = Math.floor(ts / (1000));

        if (days > 0)
            return Formaters.format("{0}, {1}:{2}:{3}s", days, hours, Formaters.padZero(mins, 2), Formaters.padZero(seconds, 2));
        else if (hours > 0)
            return Formaters.format("{0}:{1}:{2}s", hours, Formaters.padZero(mins, 2), Formaters.padZero(seconds, 2));
        else
            return Formaters.format("{0}:{1}s", mins, Formaters.padZero(seconds, 2));
    }

    static fileSize(fileSize?: number): string {
        if (fileSize == null)
            return "";

        const fs = Math.abs(fileSize);
        if (fs >= 1073741824)
            return Formaters.number(fileSize / 1024.0 / 1024.0 / 1024.0, 0) + " GB";
        if (fs >= 1048576)
            return Formaters.number(fileSize / 1024.0 / 1024.0, 0) + " MB";
        if (fs >= 1024)
            return Formaters.number(fileSize / 1024.0, 0) + " KB";

        return Formaters.number(fileSize, 0) + " Bytes";
    }


    static relativeTime(dt: Date): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);
        return m.fromNow();
    }

    static localeNumber(v: number): string {
        if (v == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        return v.toLocaleString(lang);
    }

    static relativeCalendar(dt: Date): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);
        return m.calendar();
    }

    static localeDate(dt: Date): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);
        return m.format("L");
    }


    static localeTime(dt: Date): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);
        return m.format("LT");
    }

    static localeDatetime(dt: Date): string {
        return this.localeDate(dt) + ' ' + this.localeTime(dt);
    }

    static dayMonth(dt: Date): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);

        return dt.getFullYear() == new Date().getFullYear()
            ? m.format("DD/MMM")
            : m.format("L");
    }

    static monthYear(dt: Date, hideCurrentYear: boolean = false): string {
        if (dt == null) return null;

        var lang = Session.uiCulture.toLowerCase();
        var m = moment(dt).locale(lang);

        return dt.getFullYear() == new Date().getFullYear() && hideCurrentYear
            ? m.format("MMM")
            : m.format("MMM/YYYY");
    }

    static dateRange(start: Date, end: Date): string {
        if (start == null && end == null) return null;

        if (start == null) return this.monthYear(end);
        else if (end == null) return this.monthYear(start);


        var lang = Session.uiCulture.toLowerCase();
        var s = moment(start).locale(lang);
        var e = moment(end).locale(lang);

        if (start.getFullYear() == end.getFullYear()) {

            if (start.getMonth() == end.getMonth())
                return s.format("DD") + " - " + e.format("DD/MMM");

            return s.format("DD/MMM") + " - " + e.format("DD/MMM");
        }
        else if (start.getFullYear() == new Date().getFullYear())
            return s.format("DD/MMM") + " - " + e.format("DD/MMM/YYYY");

        return s.format("DD/MMM/YYYY") + " - " + e.format("DD/MMM/YYYY");
    }

    static fullDateRange(start: Date, end: Date): string {
        if (start == null && end == null) return null;

        var lang = Session.uiCulture.toLowerCase();

        if (start != null && end == null) {
            var s = moment(start).locale(lang);
            return (start.getFullYear() == new Date().getFullYear())
                ? s.format("DD/MMM")
                : s.format("DD/MMM/YYYY");
        }

        if (start == null && end != null) {
            var e = moment(end).locale(lang);
            return (end.getFullYear() == new Date().getFullYear())
                ? e.format("DD/MMM")
                : e.format("DD/MMM/YYYY");
        }

        return this.dateRange(start, end);
    }

    static htmlHighlightTerm(term: string, searchText: string, caseSensitive: boolean = false, accentSensitive: boolean = false): string {
        const wrapper = 'b';
        const regexFlags = caseSensitive ? 'g' : "gi";

        if (term == null || term == "" || searchText == null || searchText == "") return searchText;

        function wrap(match: string): string {
            return '<' + wrapper + '>' + match + '</' + wrapper + '>';
        }

        function getAccentInsensitiveWords(words: string) {
            var accentedForms = {
                'c': 'ç',
                'C': 'Ç',
                'a': 'áàãä',
                'A': 'ÁÀÃÄ',
                'e': 'éè',
                'E': 'ÉÈ',
                'i': 'íìï',
                'I': 'ÍÌÏ',
                'o': 'óòõö',
                'O': 'ÓÒÕÖ',
                'u': 'úùü',
                'U': 'ÚÙÜ',
            };

            for (var s in accentedForms) {
                words = words.replace(new RegExp(s, 'g'), '[' + s + accentedForms[s] + ']');
            }

            return words;
        }

        const nterm = accentSensitive ? term : getAccentInsensitiveWords(term);
        const regex = new RegExp(nterm, regexFlags);
        return searchText.replace(regex, match => wrap(match));
    }

    static capitalize(text: string) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    static capitalizeAll(text: string) {
        return text.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
    }

    static capitalizedTitle(text: string) {
        var words = text.match(/\b\w+\b/g),
            preps = [
                "of", "on", "and", "or", "in", "a", "the",
                "da", "de", "do", "em", "na", "no", "a", "e", "i", "o", "u", "ou"
            ];
        return words.map((e, i) => preps.indexOf(e) == -1 || i === 0 ? e[0].toUpperCase() + e.slice(1) : e).join(" ");
    }
}